<template>
  <div class="PreviewAndroidChrome" :class="{ 's-hasImage': hasImage, 's-minimized': isMinimized, 's-hasIcon': hasIcon }" @mouseover="isMinimized = false" @mouseout="isMinimized = true">
      <div class="AppIcon"></div>
      <div class="Info">{{$t('Chrome')}} &bullet; {{base.domain}} &bullet; {{$t('NotificationsApp.now ∨')}}</div>
      <div class="Details">
          <div class="Title" v-html="base.titleSmall"></div>
          <div class="Body" v-html="base.body"></div>
      </div>
      <div v-if="hasImage && !isMinimized" class="Image" :style="{'backgroundImage': 'url(' + base.image + ')'}"></div>
      <div class="Icon" :style="{'backgroundImage': 'url(' + base.icon + ')'}">
        <div v-if="!hasIcon" class="Text">{{ base.domain.substr(0, 1) }}</div>
      </div>
      <div v-if="!isMinimized" class="Menu">
        <template v-if="hasMenu">
          <div v-html="base.action1TextSmall"></div>
          <div v-if="base.action2TextSmall" v-html="base.action2TextSmall"></div>
          <div>{{$t('Settings')}}</div>
        </template>
        <template v-if="!hasMenu">
          <div>{{$t('Site Settings')}}</div>
        </template>
      </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewAndroidChrome',
  props: {
    base: Object,
    isAndroid7AndBelow: Boolean
  },
  data() {
    return {
      isMinimized: true
    }
  },
  computed: {
    hasMenu() {
      return !!this.base.action1TextSmall
    },
    hasImage() {
      return !!this.base.image && !this.isAndroid7AndBelow
    },
    hasIcon() {
      return !!this.base.icon
    }
  }
}
</script>

<style scoped lang="less">
  .PreviewAndroidChrome {
    width: 352px;
    min-height: 81px;
    user-select: none;
    position: relative;
    border: 1px solid #e5e5e5;
    font-family: 'Roboto', sans-serif;
  }
  .AppIcon {
    width: 16px;
    height: 14px;
    position: absolute;
    top: 12px;
    left: 13px;
    background: url(../assets/icon-android-chrome.png) center center no-repeat;
    background-size: contain;
  }
  .Icon {
    width: 33px;
    height: 33px;
    background: #969696;
    position: absolute;
    top: 30px;
    right: 14px;
    border-radius: 17px;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    .Text {
      text-transform: uppercase;
      color: #fff;
      text-align: center;
      font-size: 18px;
      padding-top: 4px;
    }
  }
  .s-hasIcon .Icon {
    border-radius: 0px;
    background-color: transparent;
  }
  .Info {
    position: absolute;
    top: 12px;
    left: 33px;
    font-size: 11px;
    color: #757575;
  }
  .Details {
    margin-left: 33px;
    margin-top: 31px;
    margin-bottom: 16px;
    width: 260px;
    .Title {
      font-size: 12px;
    }
    .Body {
      font-size: 12px;
      color: #757575;

      display: -webkit-box;
      -webkit-line-clamp: 8;
      -webkit-box-orient: vertical;  
      overflow: hidden;
    }
  }
  .s-minimized .Body, .s-hasImage .Body, .Title {
    height: 17.14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .Image {
    background-color: #eee;
    background-size: cover;
    background-position: center center;
    margin-bottom: 14px;
    width: 324px;
    height: 104px;
    margin-left: 13px;
  }
  .Menu {
    height: 47px;
    background: #eee;
    color: #757575;
    text-transform: uppercase;
    & > div {
      display: inline-block;
      padding-top: 15px;
      padding-left: 12px;
      font-size: 12px;
      padding-right: 10px;
    }
  }
</style>
